<template>
  <section class="block relative z-1 rounded-lg bg-gray-200 border-0">
    <div class="px-2 md:px-4 mx-auto w-full">
      <div>
        <!-- Card stats -->
        <div class="flex flex-wrap">
          <div class="w-full lg:w-12/12 xl:w-10/12 px-4"></div>
        </div>
      </div>
    </div>

    <div
      class="relative flex flex-col min-w-0 break-words w-full mb-6 "
    >
      <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
        <form>
          <br />
          <div class="flex flex-wrap">
            <div class="w-full px-4">
              <div class="relative w-full mb-3">
                <div class="text-center mt-8">
                  <div
                    class="relative flex flex-col min-w-0 break-words w-full mb-6 rounded-lg bg-gray-200 border-0"
                  >
                    <div class="flex flex-wrap">
                      <div class="w-full xl:w-8/12 mb-12 xl:mb-0 px-2">
                        <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
                          <form>
                            <div class="flex flex-wrap">
                              <div class="w-full lg:w-12/12 px-4">
                                <div class="relative w-full mb-3">
                                  <div class="text-center mt-8 text-xl">
                                    <h4>NFT Information</h4>
                                  </div>
                                </div>
                              </div>

                              <label class="block text-gray-700 text-xs mt-4"
                                >NFT Name</label
                              >
                              <div
                                class="relative flex w-full flex-wrap items-stretch my-2"
                              >
                                <span
                                  class="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-lg items-center justify-center w-8 pl-3 py-3"
                                >
                                  <i class="fas fa-file-contract"></i>
                                </span>
                                <input
                                  type="text"
                                  placeholder="NFT Name"
                                  class="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-base shadow outline-none focus:outline-none focus:shadow-outline w-full pl-10"
                                />
                              </div>

                              <label class="block text-gray-700 text-xs mt-4"
                                >Origin</label
                              >
                              <div
                                class="relative flex w-full flex-wrap items-stretch my-2"
                              >
                                <span
                                  class="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-lg items-center justify-center w-8 pl-3 py-3"
                                >
                                  <i class="fas fa-map-marker-alt"></i>
                                </span>
                                <input
                                  type="text"
                                  placeholder="Origin"
                                  class="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-base shadow outline-none focus:outline-none focus:shadow-outline w-full pl-10"
                                />
                              </div>

                              <label class="block text-gray-700 text-xs mt-4">
                                Brief Info
                              </label>
                              <div
                                class="relative flex w-full flex-wrap items-stretch my-2"
                              >
                                <span
                                  class="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-lg items-center justify-center w-8 pl-3 py-3"
                                >
                                </span>

                                <textarea
                                  type="text"
                                  class="px-3 py-3 placeholder-gray-400 text-gray-500 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                                  rows="4"
                                >
                  Enter a brief introduction
                  </textarea
                                >
                              </div>

                              <div class="w-full lg:w-6/12">
                                <label
                                  class="block text-gray-700 text-xs mt-4 text-left"
                                  >Price</label
                                >

                                <span
                                  class="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-lg items-center justify-center w-8 pl-3 py-3"
                                >
                                  <i class="fas fa-dollar-sign"></i>
                                </span>
                                <input
                                  type="number"
                                  placeholder="Price"
                                  class="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-base shadow outline-none focus:outline-none focus:shadow-outline w-full pl-10"
                                />
                              </div>

                              <div class="w-full lg:w-6/12 pl-4">
                                <label
                                  class="block text-gray-700 text-xs mt-4 text-left"
                                  >Royalties
                                </label>

                                <span
                                  class="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3"
                                >
                                  <i class="fas fa-percent"></i>
                                </span>
                                <input
                                  type="number"
                                  placeholder="Royalties"
                                  class="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-base shadow outline-none focus:outline-none focus:shadow-outline w-full pl-10"
                                />
                              </div>
                            </div>
                          </form>

                          <div
                            class="flex flex-wrap text-justify my-6 text-gray-600"
                          >
                            <p>
                              <input type="checkbox" /> I declare that this is
                              an original artwork. I understand that no
                              plagiarism is allowed, and that the artwork can be
                              removed anytime if detected.
                            </p>
                          </div>

                          <div
                            class="flex flex-wrap text-center justify-center"
                          >
                            <a
                              href="#"
                              target="_self"
                              class="shadow-xl font-semibold text-white px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-dark-bgbb100 uppercase text-sm container"
                            >
                              Mint NFT
                            </a>
                          </div>
                        </div>
                      </div>

                      <!-- SUMMARY -->

                      <div class="w-full xl:w-4/12 xl:mb-0 px-2">
                        <div
                          class="relative flex flex-col min-w-0 break-words w-full mb-6"
                        >
                          <div class="flex-auto px-4 lg:px-2 py-10 pt-0">
                            <div class="flex flex-wrap">
                              <div class="w-full lg:w-12/12 px-4">
                                <div class="relative w-full mb-3">
                                  <div class="text-center mt-8 text-xl">
                                    <h4>NFT Upload/Preview</h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            class="rounded-t bg-white mb-0 px-6 py-6 border-solid2 pb-32 mt-6"
                          >
                            <br /><br />
                            <span
                              class="fa fa-plus text-5xl my-6 bg-gray-300 rounded-full p-5"
                            ></span>
                            <br />
                            <br />
                            <p>
                              Supported formats: <br />
                              JPG/PNG/GIF/MOV/AVI
                            </p>
                            <br />
                            <p>Size: up to 10MB</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
// import placeholder from "@/assets/img/placeholder.svg";

export default {
  data() {
    return {
      // placeholder,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  components: {},
};
</script>
